import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "pro-title",
  "data-text": "Web-Dev & Designer"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "hero-icon-div" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavSection = _resolveComponent("NavSection")!
  const _component_NameHeading = _resolveComponent("NameHeading")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(_component_NavSection),
    _createElementVNode("div", {
      class: _normalizeClass(["hero wrapper", {'parallax': !_ctx.topPage}]),
      ref: "heroSection"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_NameHeading, {
          pageScrollVal: _ctx.pageScrollVal,
          isMounted: _ctx.isMounted
        }, null, 8, ["pageScrollVal", "isMounted"])
      ]),
      _hoisted_3
    ], 2)
  ]))
}